<ng-container *ngIf="mode == 'ReadOnly'; then read; else edit"></ng-container>
<ng-template #read>

    <div class="read-only-area" [ngSwitch]="multiple">

        <ng-container *ngSwitchCase="true">

            <ng-container *ngIf="control?.value?.length; then itemsTemplate; else emptyField"></ng-container>

            <ng-template #itemsTemplate>
                <picker-item-standalone [text]="$safeNavigationMigration(item?.name)" [itemStyle]="PickerItemStyle.COLOR_BACKGROUND" [color]="$safeNavigationMigration(item?.color)" [icon]="$safeNavigationMigration(item?.icon)" *ngFor="let item of control.value" />
            </ng-template>

        </ng-container>

        <ng-container *ngSwitchCase="false">

            <picker-item-standalone [text]="$safeNavigationMigration(control?.value?.name)" [itemStyle]="PickerItemStyle.COLOR_BACKGROUND" [color]="$safeNavigationMigration(control.value?.color)" [icon]="$safeNavigationMigration(control.value?.icon)" />

        </ng-container>


    </div>

</ng-template>
<ng-template #edit>

    <ng-select [items]="data$ | async" [appendTo]="appendTo" bindLabel="name" [placeholder]="placeholder" [hideSelected]="true" [compareWith]="compareFn" [searchFn]="searchFn" [multiple]="multiple" [searchable]="true" [formControl]="control">
        <ng-template ng-option-tmp let-item="item" let-clear="clear">
            <picker-item-standalone (clear)="clear(item)" [text]="$safeNavigationMigration(item?.name)" [color]="$safeNavigationMigration(item?.color)" [icon]="$safeNavigationMigration(item?.icon)" [itemStyle]="PickerItemStyle.COLOR_BACKGROUND" />
        </ng-template>

        <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <picker-item-standalone (clear)="clear(item)" [clearable]="multiple === true && !item?.system" [text]="$safeNavigationMigration(item?.name)" [color]="$safeNavigationMigration(item?.color)" [icon]="$safeNavigationMigration(item?.icon)" [itemStyle]="PickerItemStyle.COLOR_BACKGROUND" />
        </ng-template>
    </ng-select>

</ng-template>


<ng-template #emptyField>
    <span class="empty-field">{{ emptyText }}</span>
</ng-template>